import React from "react";
import { Formik, Form, Field } from "formik";
import { TextField, Button } from "@mui/material";
import * as Yup from "yup";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {TrainingRequests} from "requests/TrainingRequests"
// Validation schema using Yup
const validationSchema = Yup.object({
    trainingName: Yup.string()
    .required("Training Name is required")
    .max(50, "Training Name cannot exceed 50 characters"),
  description: Yup.string()
    .max(200, "Description cannot exceed 200 characters")
    .optional(),
});

const AddTrainingTypeForm = ({ onSubmit, trigger, initialData, row, closeModal }) => {
  // Submit handler
  console.log("row",row)
  const handleSubmit = async (values, { resetForm }) => {
    try {
      console.log("Form Submitted:", values);
      toast.success("Training Type Submitted Successfully!", {
        theme: "colored",
      });
      if(!row){
        await TrainingRequests.createTrainingType(values)
      }else{
        await TrainingRequests.updateTrainingType(values)
      }
      resetForm();
      if(trigger){
        trigger()
      }
      if(closeModal){
        closeModal()
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      toast.error(`Failed to submit form: ${error.message}`, {
        theme: "colored",
      });
    }
  };

  return (
    <>
      <Formik
        initialValues={initialData || { trainingName: "", description: "" }}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ errors, touched, setFieldValue }) => (
          <Form>
            {/* Training Type Field */}
            <Field
              as={TextField}
              name="trainingName"
              label="Training Type"
              fullWidth
              margin="normal"
              error={touched.trainingName && !!errors.trainingName}
              helperText={touched.trainingName && errors.trainingName}
              onChange={(e) => {
                const value = e.target.value.replace(" ", "_");
                const capitalizedValue = value.split('_').map(word => 
                  word.charAt(0).toUpperCase() + word.slice(1)
                ).join('_');
                setFieldValue("trainingName", capitalizedValue);
              }}
            />

            {/* Description Field */}
            <Field
              as={TextField}
              name="description"
              label="Description"
              fullWidth
              margin="normal"
              multiline
              rows={4}
              error={touched.description && !!errors.description}
              helperText={touched.description && errors.description}
              onChange={(e) => {
                setFieldValue("description", e.target.value);
              }}
            />

            {/* Submit Button */}
            <Button
              type="submit"
              variant="contained"
              color="primary"
              fullWidth
              sx={{ mt: 2 }}
            >
              Submit
            </Button>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default AddTrainingTypeForm;
